import { fork, all } from 'redux-saga/effects'

import authenticationSagas from '@SiteModules/Authentication/sagas'
import onboardingSagas from '@SiteModules/Onboarding/sagas'
import createSubscriptionSagas from '@SiteModules/Subscription/sagas'
import projectVersionSettingsSagas from '@SiteModules/ProjectVersionSettings/sagas'
import projectVersionSettingsTtsSagas from '@SiteModules/ProjectVersionSettingsTts/sagas'
import externalTokenSagas from '@SiteModules/ExternalToken/sagas'
import projectVersionSagas from '@SiteModules/ProjectVersion/sagas'
import subtitleSagas from '@SiteModules/Subtitle/sagas'
import vocabularySagas from '@SiteModules/Vocabulary/sagas'
import guidelineSagas from '@SiteModules/Guideline/sagas'
import termbaseSagas from '@SiteModules/Termbase/sagas'
import usersSagas from '@SiteModules/User/sagas'
import labelSagas from '@SiteModules/Label/sagas'
import projectSagas from '@SiteModules/Project/sagas'
import elementSagas from '@SiteModules/Element/sagas'
import externalChannelSagas from '@SiteModules/ExternalChannel/sagas'
import themesSagas from '@SiteModules/Theme/sagas'
import exportationSaga from '@SiteModules/Exportation/sagas'
import processingSaga from '@SitePages/Processing/sagas'
import accountsSagas from '@SiteModules/Account/sagas'
import accountUsersSagas from '@SiteModules/AccountUser/sagas'
import workspacesSagas from '@SiteModules/Workspace/sagas'
import workspaceUsersSagas from '@SiteModules/WorkspaceUser/sagas'
import speakerVoiceSagas from '@SiteModules/SpeakerVoice/sagas'
import creditSagas from '@SiteModules/Credit/sagas'
import statisticsSagas from '@SiteModules/Statistics/sagas'

export default function* sagas() {
  yield all([
    fork(authenticationSagas),
    fork(onboardingSagas),
    fork(labelSagas),
    fork(usersSagas),
    fork(projectSagas),
    fork(elementSagas),
    fork(subtitleSagas),
    fork(vocabularySagas),
    fork(guidelineSagas),
    fork(termbaseSagas),
    fork(externalTokenSagas),
    fork(externalChannelSagas),
    fork(themesSagas),
    fork(createSubscriptionSagas),
    fork(projectVersionSagas),
    fork(projectVersionSettingsSagas),
    fork(projectVersionSettingsTtsSagas),
    fork(exportationSaga),
    fork(processingSaga),
    fork(accountsSagas),
    fork(accountUsersSagas),
    fork(workspacesSagas),
    fork(workspaceUsersSagas),
    fork(speakerVoiceSagas),
    fork(creditSagas),
    fork(statisticsSagas),
  ])
}
